export interface IUser{
    id: number;
    lastUserActiveDate: Date | null;
    dateAdded: Date;
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    accessStatusId: number | null;
    accessStatusName: string;
    linkedCampaignIds: number[];
    communityId: number;   
    userRoleId: number; 
}

export interface UserRequestDto{
    firstName: string;
    lastName: string;
    email: string;
    userRole: number;
    signUpSource: number;
}